<template>
  <div id="nothing">
    <!-- 暂无数据 -->
    <img src="../../assets/img/nothing.png" alt="" />
    {{ data }}
  </div>
</template>

<script>
export default {
  name: "diy_nothing",
  props: {
    tip: {
      type: String,
      defalut: "暂无数据!!!",
    },
  },
  data() {
    return {
      data: this.tip,
    };
  },
  watch: {
    tip() {
      this.data = this.tip;
    },
    data(newValue) {
      this.$emit("showTip", this.data);
    },
  },
};
</script>
<style lang="less" scoped>
#nothing {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #bebebe;
  > img {
    margin-top: 120px;
    margin-bottom: 7px;
  }
}
</style>